import { BaseApiService } from '../base/BaseApiService';
import {
  CreateUserRequest,
  UpdateUserRequest,
  UserResponse
} from '../../types/dtos';
import { ApiResponse, PaginationParams, PaginatedResponse, UserFilters } from '../../types/api';

export class UserService extends BaseApiService {
  async getUsers(params?: PaginationParams & Partial<UserFilters>): Promise<PaginatedResponse<UserResponse>> {
    const response = await this.api.get<ApiResponse<PaginatedResponse<UserResponse>>>('/users', { params });
    return this.extractData(response);
  }

  async getUserById(id: string): Promise<UserResponse> {
    const response = await this.api.get<ApiResponse<UserResponse>>(`/users/${id}`);
    return this.extractData(response);
  }

  async createUser(userData: CreateUserRequest): Promise<UserResponse> {
    const response = await this.api.post<ApiResponse<UserResponse>>('/users', userData);
    return this.extractData(response);
  }

  async updateUser(id: string, userData: UpdateUserRequest): Promise<UserResponse> {
    const response = await this.api.put<ApiResponse<UserResponse>>(`/users/${id}`, userData);
    return this.extractData(response);
  }

  async deleteUser(id: string): Promise<ApiResponse<void>> {
    const response = await this.api.delete<ApiResponse<void>>(`/users/${id}`);
    return response.data;
  }

  async renewUserToken(id: string): Promise<ApiResponse<any>> {
    const response = await this.api.post<ApiResponse<any>>(`/users/${id}/renew-token`);
    return response.data;
  }

  async activateUser(id: string): Promise<ApiResponse<void>> {
    const response = await this.api.post<ApiResponse<void>>(`/users/${id}/activate`);
    return response.data;
  }

  async deactivateUser(id: string): Promise<ApiResponse<void>> {
    const response = await this.api.post<ApiResponse<void>>(`/users/${id}/deactivate`);
    return response.data;
  }
}

// Instância singleton
export const userService = new UserService();
